<template>
    <th :id="`th-${header.sortData || header.label}`" scope="col" :class="header.sortStatus !== SortType.INACTIVE ? 'pointer' : ''" :style="getHeaderStyle(header)" v-if='header.label != "idMasquee"'>
        <div v-if="header.sortData === 'uniqueDocumentId'" class="th-wrapper" :style="getDivHeaderStyle(header)" >
            <span></span>
        </div>
        <div v-else class="th-wrapper" :class="header.sortStatus !== SortType.INACTIVE ? 'pointer' : ''" :style="getDivHeaderStyle(header)">
            <span class="header-label-group">
                <button type="button" v-if="header.sortStatus !== SortType.INACTIVE" @click="resetSort(header)" class="header-label btn-sort">
                    {{ $t(header.label) }}
                </button>
                <span v-else class="header-label">{{ $t(header.label) }}</span>
                <ReglePastille v-if="header.regleCle" :cle="header.regleCle" placement="auto" />
            </span>
            <div v-if="header.sortStatus !== SortType.INACTIVE" class="sortIcons">
                <button type="button" class="btn-sort-icon" @click.stop="setSortAsc(header)" :aria-label="$t('aria.tri.ascendant')">
                    <img
                        :src="sortUpIcon"
                        alt=""
                        aria-hidden="true"
                        :class="{'active': header.sortStatus === SortType.ASC}"
                    />
                </button>
                <button type="button" class="btn-sort-icon" @click.stop="setSortDesc(header)" :aria-label="$t('aria.tri.descendant')">
                    <img
                        :src="sortDownIcon"
                        alt=""
                        aria-hidden="true"
                        :class="{'active': header.sortStatus === SortType.DESC}"
                    />
                </button>
            </div>
        </div>
    </th>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'DataTableHeader',
    components: { ReglePastille },
    emits: ['sort'],
    data() {
        return {
            SortType,
        };
    },
    props: {
        header: { type: Object as PropType<TableHeader>, required: true },
    },
    methods: {
        // Method to set sort to ascending
        setSortAsc(tableHeader: TableHeader) {
            if (tableHeader.sortStatus !== SortType.INACTIVE) {
                this.$emit('sort', {
                    sortData: tableHeader.sortData,
                    sortStatus: SortType.ASC
                });
            }
        },

        // Method to set sort to descending
        setSortDesc(tableHeader: TableHeader) {
            if (tableHeader.sortStatus !== SortType.INACTIVE) {
                this.$emit('sort', {
                    sortData: tableHeader.sortData,
                    sortStatus: SortType.DESC
                });
            }
        },

        // Method to reset sort (NONE)
        resetSort(tableHeader: TableHeader) {
            if (tableHeader.sortStatus !== SortType.INACTIVE) {
                this.$emit('sort', {
                    sortData: tableHeader.sortData,
                    sortStatus: SortType.NONE
                });
            }
        },
        getHeaderStyle(tableHeader: TableHeader) {
            let css = '';
            if(tableHeader.width){
                css += 'width: '+tableHeader.width+';';
            }
            return css;
        },
        getDivHeaderStyle(tableHeader: TableHeader) {
            let css = '';
            if(tableHeader.textalign){
                css += 'justify-content: '+tableHeader.textalign+'';
            }
            return css;
        },
    },
    computed: {
        sortUpIcon() {
            return require('@/assets/img/sort-up.svg');
        },
        sortDownIcon() {
            return require('@/assets/img/sort-down.svg');
        },
    }
});
</script>

<style scoped>
table tr * {
    box-sizing: border-box;
    padding: 0 5px;
}

.sortIcons {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    height: 20px;
}

.sortIcons img {
    opacity: 0.5;
    cursor: pointer;
    transition: opacity 0.2s ease;
}

.sortIcons img:hover {
    opacity: 0.8;
}

.sortIcons img.active {
    opacity: 1;
}

.th-wrapper {
    padding: 0 8px 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-label-group {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
}

.header-label {
    cursor: pointer;
}
.btn-sort {
    background: none;
    border: none;
    font-family: inherit;
    font-size: inherit;
    color: inherit;
    padding: 0;
    text-align: inherit;
    font-weight: inherit;
}
.btn-sort-icon {
    background: none;
    border: none;
    padding: 0;
    line-height: 0;
    cursor: pointer;
}
</style>
